// extracted by mini-css-extract-plugin
export default {"overlay":"UA-z","bodyOpen":"VA-z","content":"WA-z","header":"XA-z","close":"YA-z","closeNoHeading":"ZA-z"};